import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/geo-success-matrix-explained")(blogRouteOptions("geo-success-matrix-explained"));
